export class WbGoogleTranslate {
  constructor() {
    this.init();
  }

  init() {
    return new Promise((resolve) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const translateElement = document.getElementById('google_translate_element');
    const translateInstance = new google.translate.TranslateElement(
      {
        pageLanguage: 'fr',
        includedLanguages: 'en',
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
      },
      translateElement,
    );
  }
}
